import { type ShipperAttachmentDetail } from '../domain/Document'
import { createShipperHttpClient } from '../infra/createShipperHttpClient'
import { ShipperRepository } from '../infra/ShipperRepository'

export type RetrieveShipperAttachmentParams = {
  shipperUuid: string
  attachmentId: number
}

export type RetrieveShipperAttachmentFactoryDependencies = {
  shipperRepository: ShipperRepository
}

export function retrieveShipperAttachmentFactory({
  shipperRepository,
}: RetrieveShipperAttachmentFactoryDependencies) {
  return async function (
    params: RetrieveShipperAttachmentParams,
    config?: { signal?: AbortSignal }
  ): Promise<ShipperAttachmentDetail> {
    return shipperRepository.retrieveShipperAttachment(
      params.shipperUuid,
      params.attachmentId,
      config
    )
  }
}

export function retrieveShipperAttachment(
  params: RetrieveShipperAttachmentParams,
  config?: { signal?: AbortSignal }
): Promise<ShipperAttachmentDetail> {
  const httpClient = createShipperHttpClient()
  const shipperRepository = new ShipperRepository({ httpClient })
  const retrieveFn = retrieveShipperAttachmentFactory({ shipperRepository })
  return retrieveFn(params, config)
}
